"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IllustrationCar = function IllustrationCar() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "66",
    height: "65",
    fill: "none",
    viewBox: "0 0 66 65"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "65",
    height: "65",
    x: "0.263",
    fill: "#F3F1F5",
    rx: "22"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#D5CCDF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M4 48h58"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2DBE9",
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M10.98 44.42h42.882c.311.002.612-.112.844-.32.233-.208.38-.495.415-.805l1.006-8.82a1.268 1.268 0 00-.685-1.272 1.253 1.253 0 00-.49-.133l-11.263-.662-5.165-7.835a1.26 1.26 0 00-1.1-.564l-16.455.68a1.256 1.256 0 00-1.148.874l-2.472 7.7-6.878.586a1.257 1.257 0 00-.842.429 1.267 1.267 0 00-.308.895l.415 8.056c.018.32.157.62.388.842.23.22.536.345.855.349z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M10.966 44.412H53.85a1.265 1.265 0 001.258-1.125l1.008-8.819a1.268 1.268 0 00-.685-1.273 1.254 1.254 0 00-.49-.132L43.675 32.4l-5.165-7.835a1.26 1.26 0 00-1.1-.564l-16.455.68a1.256 1.256 0 00-1.148.875l-2.471 7.699-6.879.586a1.257 1.257 0 00-.842.429 1.267 1.267 0 00-.308.896l.415 8.055c.019.32.157.62.388.842.23.22.537.346.855.349v0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#E2DBE9",
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M17.803 48.062c2.272 0 4.115-1.85 4.115-4.133 0-2.282-1.843-4.133-4.115-4.133-2.273 0-4.116 1.85-4.116 4.133 0 2.282 1.843 4.133 4.116 4.133zM47.587 48.062c2.273 0 4.115-1.85 4.115-4.133 0-2.282-1.842-4.133-4.115-4.133-2.272 0-4.115 1.85-4.115 4.133 0 2.282 1.843 4.133 4.115 4.133z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M17.803 48.062c2.272 0 4.115-1.85 4.115-4.133 0-2.282-1.843-4.133-4.115-4.133-2.273 0-4.116 1.85-4.116 4.133 0 2.282 1.843 4.133 4.116 4.133zM47.587 48.062c2.273 0 4.115-1.85 4.115-4.133 0-2.282-1.842-4.133-4.115-4.133-2.272 0-4.115 1.85-4.115 4.133 0 2.282 1.843 4.133 4.115 4.133z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#6F558A",
    d: "M17.803 45.79a1.857 1.857 0 001.852-1.86c0-1.028-.83-1.861-1.852-1.861a1.856 1.856 0 00-1.853 1.86c0 1.028.83 1.86 1.853 1.86zM47.587 45.79a1.856 1.856 0 001.853-1.86c0-1.028-.83-1.861-1.853-1.861a1.856 1.856 0 00-1.852 1.86c0 1.028.83 1.86 1.852 1.86z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    stroke: "#6F558A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    d: "M9.474 38.626h2.265a.502.502 0 00.503-.506v-1.263a.507.507 0 00-.503-.506H9.351l.123 2.275zM55.626 38.626h-2.408a.502.502 0 01-.504-.506v-2.022a.507.507 0 01.504-.505h2.753l-.345 3.033zM31 27h6.23c.112 0 .222.03.315.09a.543.543 0 01.21.238l2.201 4.933a.504.504 0 01-.05.5.556.556 0 01-.205.175.597.597 0 01-.267.064H31v-6zM28 27h-5.285c-.111 0-.22.04-.308.112a.537.537 0 00-.178.288l-1.213 4.933a.564.564 0 00.09.46.509.509 0 00.176.153.48.48 0 00.222.054H28v-6z"
  }));
};

var _default = IllustrationCar;
exports.default = _default;